import styles from './FormCardTitle.module.scss';

export const FormCardTitle = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <h2 className={styles.FormCardTitle}>{children}</h2>
    </>
  );
};
